import React from 'react';
import { Badge } from '../Badge';
type Stat = {
  value: string;
  label: string;
  context: string;
};
const stats: Stat[] = [{
  value: '47',
  label: 'Interruptions',
  context: 'Inbound interruptions per week, on average'
}, {
  value: '6:47pm',
  label: 'After-hours',
  context: 'When most after-hours leads come in'
}, {
  value: '3.2 hrs',
  label: 'Lost focus',
  context: 'Daily time spent context-switching to inbound'
}, {
  value: '0',
  label: 'Evenings off',
  context: 'Evenings off until now'
}];
export function JobToBeDone() {
  return <section className="w-full border-b border-gray-200 bg-gray-50 px-4 sm:px-6 lg:px-12 py-12 sm:py-20 lg:py-24" data-id="element-167">
      <div className="mx-auto max-w-[1280px]" data-id="element-168">
        {/* Header */}
        <div className="flex flex-col items-center gap-4 text-center max-w-2xl mx-auto mb-10 sm:mb-14" data-id="element-169">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-orange-brand-500 text-white uppercase tracking-[0.15em] text-[11px] font-semibold" data-id="element-170">
            The other ROI
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-900 tracking-tight leading-[1.1]" data-id="element-171">
            You don't need another sales channel. You need your evenings back.
          </h2>
          <p className="text-base text-gray-600 leading-relaxed" data-id="element-172">
            While you're under a sink, on a roof, or at the dinner table, your
            phone is buzzing with leads that demand an instant response.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5" data-id="element-173">
          {stats.map((stat, i) => <div key={i} className="border border-gray-300 rounded-2xl bg-white p-6 sm:p-7 flex flex-col gap-2" data-id="element-174">
              <div className="text-4xl sm:text-5xl font-mono font-semibold tabular-nums text-navy-500 leading-none mb-1" data-id="element-175">
                {stat.value}
              </div>
              <div className="text-[11px] uppercase tracking-[0.15em] font-semibold text-gray-500" data-id="element-176">
                {stat.label}
              </div>
              <div className="text-sm text-gray-600 leading-relaxed" data-id="element-177">
                {stat.context}
              </div>
            </div>)}
        </div>

        {/* Closing Band */}
        <div className="border-2 border-navy-500 rounded-2xl bg-white p-6 sm:p-8 mt-10 sm:mt-14 flex flex-col items-center gap-4 text-center" data-id="element-178">
          <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 tracking-tight" data-id="element-179">
            speed-to-lead gives you those hours back.
          </h3>
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-sm text-gray-600 font-medium" data-id="element-180">
            <span data-id="element-181">Always-on inbound</span>
            <span className="hidden sm:inline text-gray-300" aria-hidden data-id="element-182">
              ·
            </span>
            <span data-id="element-183">No staff to hire</span>
            <span className="hidden sm:inline text-gray-300" aria-hidden data-id="element-184">
              ·
            </span>
            <span data-id="element-185">You stay focused on the job</span>
          </div>
        </div>
      </div>
    </section>;
}